import {
  Component,
  EventEmitter,
  Input,
  OnInit,
  Output,
  TemplateRef,
  ViewChild,
  ViewContainerRef,
} from '@angular/core';
import { EventResponseEvent } from '../../../types/event-response.type';
import { ICONS } from '../../../constants/constants';
import { UtilsService } from '../../../services/utils.service';
import { DateTimeService } from '../../../services/date-time.service';

@Component({
  selector: 'app-event-management-event-row',
  templateUrl: './event-management-event-row.component.html',
  styleUrls: ['./event-management-event-row.component.scss'],
})
export class EventManagementEventRowComponent implements OnInit {
  protected readonly ICONS = ICONS;

  @Input() event: EventResponseEvent;

  @Output() edit: EventEmitter<EventResponseEvent> =
    new EventEmitter<EventResponseEvent>();
  @Output() delete: EventEmitter<EventResponseEvent> =
    new EventEmitter<EventResponseEvent>();

  @ViewChild('template', { static: true })
  template: TemplateRef<HTMLTableRowElement>;

  constructor(private viewContainerRef: ViewContainerRef) {}

  ngOnInit(): void {
    this.viewContainerRef.createEmbeddedView(this.template);
  }

  deleteEvent(): void {
    this.delete.emit(this.event);
  }

  editEvent(): void {
    this.edit.emit(this.event);
  }

  get eventLocation(): string {
    return UtilsService.parseLocation(this.event.event_location)?.country ?? '';
  }

  get eventDate(): string {
    return DateTimeService.formatDate(this.event.event_start);
  }

  get eventHiddenCategoryCount(): string {
    return `+${this.event.categories.length - 1}`;
  }
}
